import { formatToUSD } from "../../../utils/misc";
import { DiscountControllerOptionFragment } from "./DiscountSelect-generated.hooks";

export function getDiscountDescription(
  discount?: DiscountControllerOptionFragment,
  currencyIso?: string,
) {
  if (discount?.discountType?.discountType === "FLAT") {
    return `-${formatToUSD(discount.amount || 0, currencyIso)}`;
  }

  if (discount?.discountType?.discountType === "PERCENT") {
    return `-${discount.amount || 0}%`;
  }

  return "";
}
